import s from "react";
import a from "./index.es56.js";
function o(t, r) {
  let e;
  t.children.length > 0 && (e = t.children[0].data);
  const l = a(t.attribs, r);
  return s.createElement("style", l, e);
}
export {
  o as default
};
//# sourceMappingURL=index.es36.js.map
